// Enum-like constant you can reference as SubscriptionStatus.ACTIVE
export const SubscriptionStatus = {
  ACTIVE: "ACTIVE",
  TRIALING: "TRIALING",
  PAST_DUE: "PAST_DUE",
  CANCELED: "CANCELED",
  EXPIRED: "EXPIRED",
  SUSPENDED: "SUSPENDED",
} as const;

// Union type: "ACTIVE" | "TRIALING" | ...
export type SubscriptionStatus =
  typeof SubscriptionStatus[keyof typeof SubscriptionStatus];

export type Entitlements = {
  send_meeting_invites?: boolean;
  send_invoices?: boolean;
  postal_mail?: boolean;
  storage_mb?: number;
  members_limit?: number;
};

export interface SubscriptionSummary {
  status: SubscriptionStatus;
  planCode?: string;
  trialActive?: boolean;
  trialEnd?: string | null;
  entitlements: Entitlements;
}
